import { useTheme } from '@emotion/react';
import { useAtom, useSetAtom } from 'jotai';
import React, { useEffect } from 'react';

import { Box } from '~/components/blocks';
import { tracingReportPageInfoState } from '~/state/partials/tracingreport_panel/atoms';
import { lineVisitorFileState } from '~/state/reception/atoms';

import { TracingReport } from './TracingReport';

type Props = {
  lineVisitorId: string;
};
export const FilePane = (props: Props) => {
  const theme = useTheme();
  const { lineVisitorId } = props;
  const setPageInfo = useSetAtom(tracingReportPageInfoState);
  const [lineVisitorFile, setLineVisitorFile] = useAtom(lineVisitorFileState);

  useEffect(() => {
    if (lineVisitorFile.lineVisitorId !== lineVisitorId) {
      setPageInfo((_state) => ({
        ..._state,
        target: 'GuestPatient',
        targetId: lineVisitorFile.lineVisitorId,
        page: 1,
        totalPage: 1,
      }));

      setLineVisitorFile((_state) => ({
        ..._state,
        lineVisitorId,
      }));
    }
  }, [lineVisitorId, lineVisitorFile.lineVisitorId, setPageInfo, setLineVisitorFile]);

  return (
    <Box position="relative" height="100%" overflow="auto" padding={theme.space.l}>
      <TracingReport lineVisitorId={lineVisitorId} />
    </Box>
  );
};
